import {
  IRecord,
  IRecordType,
  IRect,
  IRectSize,
  IRectSizeType,
  IRectType
} from 'annotation-tools/utils';

type ImageInfoType = {
  id: number;
  name: string;
  fileUri: string; // 画像ファイル URI
  fileGuid: string;
  size: IRectSizeType;
  cropRect: IRectType;
  numAnnotations: number;
  isAnnotated: boolean; // アノテーション済み
};

type ProjectImageInfoType = ImageInfoType & { modelId: number | undefined };

// immutable type
export type IImageInfoType = IRecordType<ImageInfoType>;

export type IProjectImageInfoType = IRecordType<ProjectImageInfoType>;

const defaultValues: ImageInfoType = {
  id: 0,
  name: '',
  fileUri: '',
  fileGuid: '',
  size: IRectSize(),
  cropRect: IRect(),
  numAnnotations: 0,
  isAnnotated: false
};

// immutable object generator
export const IImageInfo = IRecord<ImageInfoType>(defaultValues);

export const IProjectImageInfo = IRecord<ProjectImageInfoType>({
  ...defaultValues,
  modelId: undefined
});
